import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http_auth, http_no_auth} from "@utils"
import {toast} from "react-toastify"
import {REFRESH_TOKEN} from "../../../utility/Utils"
import * as auth from "../Auth"

export const getUsersList = createAsyncThunk('user_controller/getUsersList', async (data, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_auth.post('/admin/v1/user/list', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
        return rejectWithValue(error.message)
    }
})

export const getUserChanges = createAsyncThunk('user_controller/getUserChanges', async (userId, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_auth.post(`/admin/v1/user/user-changes/${userId}`)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
        return rejectWithValue(error.message)
    }
})

export const getUserById = createAsyncThunk('user_controller/getUserById', async (data, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_auth.post('/admin/v1/user/list', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data?.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
        return rejectWithValue(error.message)
    }
})

export const createNewUser = createAsyncThunk('user_controller/createNewUser', async (data, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_auth.post('/admin/v1/user/save', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data?.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
        return rejectWithValue(error.message)
    }
})

export const getRolesList = createAsyncThunk('user_controller/getRolesList', async (data, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_auth.post('/admin/v1/role/list', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data?.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
        return rejectWithValue(error.message)
    }
})

export const createNewRole = createAsyncThunk('user_controller/createNewRole', async (data, {rejectWithValue}) => {
    try {
        const response = await http_auth.post('/admin/v1/role/save', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data?.data
    } catch (error) {
        return rejectWithValue(error.message)
    }
})

export const getPositionList = createAsyncThunk('user_controller/getPositionList', async (data, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_auth.post('/admin/v1/position/list', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
        return rejectWithValue(error.message)
    }
})

export const createNewPosition = createAsyncThunk('user_controller/createNewPosition', async (data, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_auth.post('/admin/v1/position/save', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        dispatch(getPositionList({}))
        return response.data?.data
    } catch (error) {
        return rejectWithValue(error.message)
    }
})

export const getOrganizationList = createAsyncThunk('user_controller/getOrganizationList', async (data, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_no_auth.post('/admin/v1/organization/list', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
        return rejectWithValue(error.message)
    }
})

export const getOrganizationListForFilter = createAsyncThunk('user_controller/getOrganizationListForFilter', async (data, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_no_auth.post('/admin/v1/organization/list', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
        return rejectWithValue(error.message)
    }
})

export const getOrganizationById = createAsyncThunk('user_controller/getOrganizationById', async (data, {rejectWithValue}) => {
    try {
        const response = await http_no_auth.post('/admin/v1/organization/list', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        return rejectWithValue(error.message)
    }
})

export const getOrganizationRegionList = createAsyncThunk('user_controller/getOrganizationRegionList', async (data, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_no_auth.post('/admin/v1/organization/list', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
        return rejectWithValue(error.message)
    }
})
export const getOrganizationDistrictList = createAsyncThunk('user_controller/getOrganizationDistrictList', async (data, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_no_auth.post('/admin/v1/organization/list', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
        return rejectWithValue(error.message)
    }
})

export const createNewOrganization = createAsyncThunk('user_controller/createNewOrganization', async (data, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_auth.post('/admin/v1/organization/save', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data?.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
        return rejectWithValue(error.message)
    }
})


export const getMonitoringLogs = createAsyncThunk('user_controller/getMonitoringLogs', async (data, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_auth.post('/admin/v1/log/actions', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
        return rejectWithValue(error.message)
    }
})
export const getMonitoringLogId = createAsyncThunk('user_controller/getMonitoringLogId', async (data, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_auth.get(`/admin/v1/log/action/${data}`)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
        return rejectWithValue(error.message)
    }
})
// export const getMonitoringLogs = createAsyncThunk('user_controller/getMonitoringLogs', async (data, {
//     rejectWithValue,
//     dispatch
// }) => {
//     try {
//         const response = await http_auth.post('/admin/v1/request-log/list', data)
//         if (response.data?.data === null) return rejectWithValue(response.data.message)
//         return response.data
//     } catch (error) {
//         if (error.response.status === 401) {
//             return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
//         }
//         return rejectWithValue(error.message)
//     }
// })

export const getMonitoringSmsList = createAsyncThunk('user_controller/getMonitoringSmsList', async (data, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_auth.post('/integration/v1/sms/list', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data?.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
        return rejectWithValue(error.message)
    }
})

export const getMonitoringSmsByObjectId = createAsyncThunk('user_controller/getMonitoringSmsByObjectId', async (data, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_auth.post('/integration/v1/sms/list', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data?.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
        return rejectWithValue(error.message)
    }
})

export const sendSms = createAsyncThunk('user_controller/sendSms', async (data, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_auth.post('/integration/v1/sms/send', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data?.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
        return rejectWithValue(error.message)
    }
})

export const getSystemConfig = createAsyncThunk('user_controller/getSystemConfig', async (data, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_auth.post('/admin/v1/system-config/list', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
        return rejectWithValue(error.message)
    }
})

export const saveSystemConfig = createAsyncThunk('user_controller/saveSystemConfig', async (data, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_auth.post('/admin/v1/system-config/save', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
        return rejectWithValue(error.message)
    }
})

export const userControllerSlice = createSlice({
    name: 'userController',
    initialState: {
        membersList: [],
        userChanges: [],
        rolesList: [],
        userById: {},
        positionList: [],
        systemConfig: [],
        logs: [],
        logId: null,
        smsList: [],
        organizationList: [],
        organization_list_filter: [],
        organizationById: {},
        organizationRegionList: [],
        organizationDistrictList: [],
        smsByObject: null,
        count_item_user: 0,
        total_count_user: 0,
        current_page_user: 0,

        count_item: 0,
        total_count: 0,
        current_page: 0,
        isLoading: false
    },
    reducers: {},
    extraReducers: {
        [getUsersList.fulfilled]: (state, actions) => {
            state.membersList = actions.payload?.data
            state.current_page_user = actions.payload?.page
            state.count_item_user = actions.payload?.count
            state.total_count_user = actions.payload?.total_count
            state.isLoading = false
        },
        [getUsersList.pending]: (state) => {
            state.isLoading = true
        },
        [getUsersList.rejected]: (state) => {
            toast.error("Error")
            state.isLoading = false
        },

        [getUserChanges.fulfilled]: (state, actions) => {
            state.userChanges = actions.payload?.data
            state.isLoading = false
        },
        [getUserChanges.pending]: (state) => {
            state.isLoading = true
        },
        [getUserChanges.rejected]: (state, action) => {
            toast.error(action.payload)
            state.isLoading = false
        },

        [getSystemConfig.fulfilled]: (state, actions) => {
            state.systemConfig = actions.payload?.data
            state.current_page = actions.payload?.page
            state.count_item = actions.payload?.count
            state.total_count = actions.payload?.total_count
            state.isLoading = false
        },
        [getSystemConfig.pending]: (state) => {
            state.isLoading = true
        },
        [getSystemConfig.rejected]: (state, action) => {
            toast.error(action.payload)
            state.isLoading = false
        },

        [getUserById.fulfilled]: (state, action) => {
            state.userById[action?.meta?.arg?.id] = action.payload[0]
            state.isLoading = false
        },
        [getUserById.pending]: (state) => {
            state.isLoading = true
        },
        [getUserById.rejected]: (state, actions) => {
            toast.error(actions.payload)
            state.isLoading = false
        },

        [createNewUser.fulfilled]: (state) => {
            state.isLoading = false
        },
        [createNewUser.pending]: (state) => {
            state.isLoading = true
        },
        [createNewUser.rejected]: (state) => {
            toast.error("Error")
            state.isLoading = false
        },

        [getRolesList.fulfilled]: (state, actions) => {
            state.rolesList = actions.payload
            state.isLoading = false
        },
        [getRolesList.pending]: (state) => {
            state.isLoading = true
        },
        [getRolesList.rejected]: (state) => {
            toast.error("Error")
            state.isLoading = false
        },

        [getPositionList.fulfilled]: (state, action) => {
            state.positionList = action.payload?.data
            state.current_page = action.payload?.page
            state.count_item = action.payload?.count
            state.total_count = action.payload?.total_count
            state.isLoading = false
        },
        [getPositionList.pending]: (state) => {
            state.isLoading = true
        },
        [getPositionList.rejected]: (state) => {
            toast.error("Error")
            state.isLoading = false
        },

        [getOrganizationListForFilter.fulfilled]: (state, action) => {
            state.organization_list_filter = action.payload?.data
        },

        [createNewOrganization.fulfilled]: (state, action) => {
            state.organizationList.push(action.payload)
        },
        [getOrganizationList.fulfilled]: (state, action) => {
            state.organizationList = action.payload?.data
            state.current_page = action.payload?.page
            state.count_item = action.payload?.count
            state.total_count = action.payload?.total_count
            state.isLoading = false
        },
        [getOrganizationList.pending]: (state) => {
            state.isLoading = true
        },
        [getOrganizationList.rejected]: (state) => {
            toast.error("Error")
            state.isLoading = false
        },

        [getOrganizationById.fulfilled]: (state, action) => {
            state.organizationById[action?.meta?.arg?.id] = action.payload?.data
        },
        [getOrganizationRegionList.fulfilled]: (state, action) => {
            state.organizationRegionList = action.payload?.data
            state.current_page = action.payload?.page
            state.count_item = action.payload?.count
            state.total_count = action.payload?.total_count
        },
        [getOrganizationDistrictList.fulfilled]: (state, action) => {
            state.organizationDistrictList = action.payload?.data
            state.current_page = action.payload?.page
            state.count_item = action.payload?.count
            state.total_count = action.payload?.total_count
        },

        [getMonitoringLogs.fulfilled]: (state, actions) => {
            state.logs = actions.payload?.data
            state.current_page = actions.payload?.page
            state.count_item = actions.payload?.count
            state.total_count = actions.payload?.total_count
            state.isLoading = false
        },
        [getMonitoringLogs.pending]: (state) => {
            state.isLoading = true
        },
        [getMonitoringLogs.rejected]: (state) => {
            toast.error("Error")
            state.isLoading = false
        },
        [getMonitoringLogId.fulfilled]: (state, actions) => {
            state.logId = actions.payload?.data
            state.isLoading = false
        },
        [getMonitoringLogId.pending]: (state) => {
            state.isLoading = true
        },
        [getMonitoringLogId.rejected]: (state) => {
            toast.error("Error")
            state.isLoading = false
        },

        [getMonitoringSmsList.fulfilled]: (state, actions) => {
            state.smsList = actions.payload?.data
            state.current_page = actions.payload?.page
            state.count_item = actions.payload?.count
            state.total_count = actions.payload?.total_count
            state.isLoading = false
        },
        [getMonitoringSmsList.pending]: (state) => {
            state.isLoading = true
        },
        [getMonitoringSmsList.rejected]: (state) => {
            toast.error("Error")
            state.isLoading = false
        },

        [getMonitoringSmsByObjectId.fulfilled]: (state, actions) => {
            if (actions.payload?.data?.length !== 0) {
                state.smsByObject = actions.payload?.data[actions.payload?.data?.length - 1]
                if (actions.payload?.data[actions.payload?.data?.length - 1]?.status !== "SENT_SMS") {
                    toast.info(actions?.payload?.data[actions.payload?.data?.length - 1]?.content)
                }
            } else {
                toast.warning("Ariza bo`yicha eslatma mavjud emas")
            }
            state.isLoading = false
        },
        [getMonitoringSmsByObjectId.pending]: (state) => {
            state.isLoading = true
        },
        [getMonitoringSmsByObjectId.rejected]: (state) => {
            toast.error("Error")
            state.isLoading = false
        }
    }
})

export const {} = userControllerSlice.actions
export default userControllerSlice.reducer
